export default "__VITE_ASSET__CMdrZfE0__"